/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { numericDependencies } from './dependenciesNumeric.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createDivideScalar } from '../../factoriesAny.js';
export var divideScalarDependencies = {
  numericDependencies: numericDependencies,
  typedDependencies: typedDependencies,
  createDivideScalar: createDivideScalar
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDivideScalar.generated.js
// module id = 42
// module chunks = 0